<template>
  <!-- 헤더와 푸터가 필요한 페이지입니다. -->
  <div class="container policy-wrap">
    <div class="policy">
      <h2 class="heading">
        개인정보처리방침
      </h2>
      <!-- 1조 -->
      <div>
        <p class="intro">
          "어머니 사랑과 평화의 날" 캠페인(이하 “캠페인”)은 『개인정보 보호법』, 『정보통신망 이용촉진 및 정보보호에
          관한 법률』에 따라 개인정보보호 규정을 준수합니다. 회원의  개인정보 보호와 관련한 고충을 신속하게 처리하기
          위해 개인정보 처리 방침을 수립·공개합니다. 본 개인정보 처리방침은 하나님의 교회에서 제공하는 서비스 중
          캠페인에만 적용됩니다.
        </p>
        <div>
          <h3>제1조 (개인정보의 수집에 대한 동의)</h3>
          <p>
            캠페인은 정보주체의 동의에 따라 필요한 개인정보를 수집하며, 정보주체가 동의한 목적 외에는 사용하지 않습니다.
            서비스 제공 및 이벤트 참여, 프로모션 등 특정 목적을 위해 개인정보가 필요할 경우, 관련 법령에 따라 명확한
            동의를 얻은 후 사용합니다.
          </p>
        </div>
        <!-- 2조 -->
        <div>
          <h3>제2조 (개인정보 처리 목적)</h3>
          <p>
            캠페인은 정보주체의 동의에 따라 필요한 개인정보를 수집하며, 정보주체가 동의한 목적 외에는 사용하지 않습니다.
            서비스 제공 및 이벤트 참여, 프로모션 등 특정 목적을 위해 개인정보가 필요할 경우, 관련 법령에 따라 명확한
            동의를 얻은 후 사용합니다.
          </p>
          <ul>
            <li>
              <b>1. 회원 가입 및 관리:</b>
              <div>회원 가입, 본인 확인 및 인증, 맞춤형 서비스 제공, 이벤트 참여 기회 제공 등을 목적으로 합니다.</div>
            </li>
            <li>
              <b>2. 민원처리:</b>
              <div>민원인의 신원 확인, 민원 사항 확인, 처리 결과 통보 등의 목적으로 개인정보를 처리합니다.</div>
            </li>
            <li>
              <b>3. 이벤트 및 홍보:</b>
              <div>캠페인 관련 이벤트 및 프로모션에 따른 정보 제공, 경품 발송 등의 목적으로 개인정보를 이용합니다.</div>
            </li>
          </ul>
        </div>
        <!-- 3조 -->
        <div>
          <h3>제3조 (처리하는 개인정보의 항목)</h3>
          <p>캠페인은 다음과 같은 개인정보를 수집합니다.</p>
          <ul>
            <li>
              <b>1. SNS 회원가입 시: </b>
              <table>
                <thead>
                  <tr>
                    <th>구분</th>
                    <th>필수</th>
                    <!-- <th>선택</th> -->
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th>카카오톡</th>
                    <td>이메일 주소</td>
                    <!-- <td>이메일, 성별</td> -->
                  </tr>
                  <tr>
                    <th>구글</th>
                    <td>이메일 주소</td>
                    <!-- <td>성별</td> -->
                  </tr>
                </tbody>
              </table>
            </li>
            <li>
              <b>2. 서비스 이용과정에서 자동으로 생성되는 정보:</b>
              <div>보안관리 및 사용자 경험 개선을 위해 : 접속 로그, 쿠키, IP 정보, 이용기록</div>
            </li>
          </ul>
        </div>
        <!-- 4조 -->
        <div>
          <h3>제4조 (쿠키 사용 목적 및 설정 방법)</h3>
          <p>
            캠페인은 맞춤형 서비스 제공을 위해 쿠키를 사용할 수 있으며, 회원이 브라우저 설정을 통해 쿠키 설치를 거부할
            수 있습니다.
          </p>
          <div class="tx14 pd-t-10">
            <b>설정방법:</b>
          </div>
          <ul>
            <li>
              <b class="fw500">1. 인터넷 익스플로러</b>
              <div>도구 > 인터넷 옵션 > 개인정보 > 설정</div>
            </li>
            <li>
              <b class="fw500">2. 크롬</b>
              <div>설정 > 고급 설정 > 개인정보 및 보안 > 콘텐츠 설정 > 쿠키</div>
            </li>
          </ul>
          <div class="pd-t-10 desc">
            ※ 사용하시는 브라우저에 따라 상이할 수 있으며, 브라우저 도움말을 참조하세요.
          </div>
        </div>
        <!-- 5조 -->
        <div>
          <h3>제5조 (개인정보의 처리 및 보유기간)</h3>
          <p>
            캠페인은 수집된 개인정보를 회원 탈퇴 시 지체 없이 파기하며, 다음과 같은 경우 관련 법령 및 내부 방침에 따라
            일정 기간 동안 보유할 수 있습니다.
          </p>
          <ul>
            <li>
              <b>1. 법령에 따른 보유</b>
              <div>통신비밀보호법: 로그 기록 3개월</div>
            </li>
            <li>
              <b>2. 게시글 및 댓글 등 사용자 생성 콘텐츠의 보유</b>
              <div>
                회원 탈퇴 시 해당 회원의 게시글과 댓글은 3년 동안 보관 후 삭제됩니다. 이 기간 동안 보관된 데이터는
                서비스 운영, 분쟁 해결 및 악성 이용 방지 등의 목적으로만 사용됩니다.
              </div>
            </li>
          </ul>
          <p>캠페인은 보유 기간이 경과하거나 처리 목적이 달성된 개인정보를 지체 없이 파기합니다.</p>
        </div>
        <!-- 6조 -->
        <div>
          <h3>제6조 (개인정보의 제3자 제공)</h3>
          <p>
            캠페인은 수집된 개인정보를 회원 탈퇴 시 지체 없이 파기하며, 다음과 같은 경우 관련 법령 및 내부 방침에 따라
            일정 기간 동안 보유할 수 있습니다.
          </p>
          <ul>
            <li>
              <b>1. 회원의 별도 동의가 있는 경우</b>
              <div>
                제3자 제공 시 제공받는 자, 제공 목적, 제공되는 개인정보 항목, 보유 및 이용 기간 등을 회원에게 알리고
                사전 동의를 받습니다.
              </div>
            </li>
            <li>
              <b>2. 법률의 특별한 규정이 있는 경우</b>
              <div>법령에서 개인정보 제공을 요구할 때에는 해당 법령의 규정에 따라 필요한 범위 내에서만 제공합니다.</div>
            </li>
          </ul>
          <p>캠페인은 이러한 사유가 없는 한 회원의 개인정보를 제3자에게 제공하지 않습니다.</p>
        </div>
        <!-- 7조 -->
        <div>
          <h3>제7조 (개인정보의 처리 위탁)</h3>
          <p>캠페인은 이용자의 개인정보 처리를 외부 업체에 위탁하고 있지 않습니다.</p>
        </div>
        <!-- 8조 -->
        <div>
          <h3>제8조 (회원의 권리 및 행사 방법)</h3>
          <p>
            정보주체는 자신의 개인정보를 조회하거나 수정할 수 있으며, 정보주체는 회원탈퇴를 통해 개인정보의 수집 및 이용
            동의를 철회할 수 있습니다.
          </p>
        </div>
        <!-- 9조 -->
        <div>
          <h3>제9조 (개인정보의 파기)</h3>
          <p>
            캠페인은 원칙적으로 개인정보의 보유 기간이 만료되거나 처리 목적이 달성된 경우, 지체 없이 해당 개인정보를
            파기합니다. 개인정보 파기 절차와 방법은 다음과 같습니다.
          </p>
          <ul>
            <li>
              <b>1. 파기 절차</b>
              <div>
                수집 및 이용 목적이 달성된 개인정보는 내부 방침 및 관련 법령에 따라 일정 기간 저장된 후 파기됩니다.
              </div>
            </li>
            <li>
              <b>2. 파기 방법</b>
              <div>
                <b class="fw500">1) 전자적 파일: </b>
                <div>개인정보가 저장된 데이터베이스에서는 삭제 명령어를 사용하여 데이터를 제거합니다.</div>
              </div>
              <div>
                <b class="fw500">2) 종이 문서: </b>
                <div>종이에 출력된 개인정보는 분쇄기로 분쇄하거나 소각하여 안전하게 파기합니다.</div>
              </div>
              <p>
                캠페인은 개인정보의 안전한 관리를 위해 불필요한 정보와 사용자 생성 콘텐츠를 정기적으로 점검하고, 보유
                기간이 경과한 정보는 신속히 삭제합니다.
              </p>
            </li>
          </ul>
        </div>
        <!-- 10조 -->
        <div>
          <h3>제10조 (개인정보 보호책임자 및 담당자 연락처)</h3>
          <p>
            캠페인은 회원의 개인정보 보호와 관련한 문의 및 불만 처리를 위해 개인정보 보호책임자를 지정하고 있습니다.
            개인정보와 관련된 문의사항이 있으실 경우 아래의 연락처로 연락하시면 신속하고 성실하게 답변드리겠습니다.
          </p>
          <div class="policy-list">
            <!-- <div class="tx14">
              <strong class="fw500">개인정보 보호책임자:</strong> 홍길동 (개인정보위원회 대표)
            </div>
            <div class="tx14">
              <strong class="fw500">소속부서:</strong> 개인정보위원회
            </div>
            <div class="tx14">
              <strong class="fw500">직책:</strong> 팀장
            </div>
            <div class="tx14">
              <strong class="fw500">연락처:</strong> <em>Tel.</em> 010-1234-5678  / <em>E-mail.</em> privacy@church.org
            </div> -->

            <div class="tx14">
              <strong class="fw500">하나님의교회 개인정보위원회:</strong> privacy@church.org
            </div>
          </div>
        </div>
        <!--  -->
        <div class="pd-t-30 tx14">
          이 개인정보 처리방침은 <strong class="fw500">2024년 11월 10일</strong>부터 적용됩니다.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const withdrawGb = ref(100)
const reason = ref('')

watch(reason, (val) => {
  if (val.length > 200) {
    reason.value = val.slice(0, 200)
  }
})

function hanldeInputChange(event: any) {
  if (reason.value.length > 200) {
    reason.value = reason.value.slice(0, 200)
  }
  else {
    reason.value = event.target.value
  }
}
</script>

<style scoped>
@import '~/assets/css/setting.css';
</style>
